import { BuiltInTooltip } from '../../tooltip/types';

const metric = (key, label, color, units, multiplier) => ({
    key,
    label,
    color,
    units,
    multiplier,
});

export const interfaceUtilization = {
    tooltip: BuiltInTooltip,
    title: 'Utilization',
    chartType: 'line',
    yAxisTitle: 'Utilization(%)',
    statusMetric: 'statusInterfaceUtil',
    chartTrends: [metric('avgNetworkIn', 'In', '#a069db', '%', 1), metric('avgNetworkOut', 'Out', '#55BDE0', '%', 1)],
};

export const interfacePackets = {
    title: 'Packets',
    chartType: 'line',
    yAxisTitle: 'Packets/s',
    statusMetric: 'none',
    chartTrends: [
        {
            key: 'packetsInRate',
            label: 'In',
            color: '#a069db',
        },
        {
            key: 'packetsOutRate',
            label: 'Out',
            color: '#55BDE0',
        },
    ],
};

export const interfaceErrors = {
    title: 'Errors',
    chartType: 'line',
    yAxisTitle: 'Errors',
    statusMetric: 'statusInterfaceErrors',
    chartTrends: [
        {
            key: 'errorsInCount',
            label: 'In',
            color: '#a069db',
        },
        {
            key: 'errorsOutCount',
            label: 'Out',
            color: '#55BDE0',
        },
    ],
};

export const interfaceDiscards = {
    title: 'Discards',
    chartType: 'line',
    yAxisTitle: 'Discards(%)',
    statusMetric: 'statusInterfaceDiscards',
    chartTrends: [
        {
            key: 'discardsInPercent',
            label: 'In',
            color: '#a069db',
        },
        {
            key: 'discardsOutPercent',
            label: 'Out',
            color: '#55BDE0',
        },
    ],
};
